/* import __COLOCATED_TEMPLATE__ from './pending-invites-modal.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { dropTask, enqueueTask } from 'ember-concurrency';
import { inject as service } from '@ember/service';
import { closeModal } from 'sh-www/utils/modal-controls';

class PendingInvitesModal extends Component {
  @service('state-managers/application') applicationStateManager;
  @service session;

  @tracked pendingInvites = [];
  @tracked removedInvites = {};
  @tracked pagination = null;
  @tracked currentPage = 1;

  get filteredPendingInvites() {
    return this.pendingInvites.filter(invite => !this.removedInvites[invite.id] === true);
  }

  get hasMorePages() {
    return this.pagination ? this.pagination.currentPage < this.pagination.totalPages : false;
  }

  @dropTask
  *loadInvitedSellers() {
    try {
      const response = yield this.args.model.loadInvitedSellersTask.perform(this.session.currentUser.company.id, this.currentPage);
      this.pendingInvites = this.pendingInvites.concat(response.invites);
      this.pagination = response.pagination;
      this.currentPage += 1;
    } catch (error) {
      throw error;
    }
  }

  @enqueueTask
  *removeInvitedUserTask(invite) {
    try {
      yield this.args.model.removeInvitedUserTask.perform(invite);
      this.applicationStateManager.addToast(`${invite.email} removed from network`);
      this.removedInvites = { ...this.removedInvites, [invite.id]: true };
    } catch (error) {
      this.applicationStateManager.addToast('Remove invite failed. Try again later.');
    }
  }

  @enqueueTask
  *resendInviteTask(invite) {
    try {
      yield this.args.model.resendInviteTask.perform(invite);
      this.applicationStateManager.addToast('Email invite sent again');
    } catch (error) {
      this.applicationStateManager.addToast('Email failed to resend. Try again later.');
      throw error;
    }
  }

  @action
  onTrigger() {
    if (this.hasMorePages) {
      this.loadInvitedSellers.perform();
    }
  }

  @action
  handleDismiss() {
    closeModal(this);
  }
}

export default PendingInvitesModal;
